(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }

  function moneyFromCents(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var noDecimals = format.indexOf('amount_no_decimals') !== -1;
    var value = noDecimals
      ? Math.round(cents / 100).toString()
      : (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/, value);
  }

  // Shopify's CDN accepts a `width` query param on any image URL returned
  // by the /products/{handle}.js endpoint (these are already full CDN
  // URLs, just without Liquid's image_url sizing baked in).
  function sizedImage(src, width) {
    if (!src) return '';
    var sep = src.indexOf('?') === -1 ? '?' : '&';
    return src + sep + 'width=' + width;
  }

  function findColorOption(product) {
    var idx = -1;
    (product.options || []).forEach(function (name, i) {
      if (name === 'Color' || name === 'Colour') idx = i;
    });
    return idx; // 0-based index into option1/2/3, or -1
  }

  function swatchesHtml(product) {
    var colorIdx = findColorOption(product);
    if (colorIdx === -1) return '';

    var seen = {};
    var values = [];
    product.variants.forEach(function (v) {
      var val = [v.option1, v.option2, v.option3][colorIdx];
      if (val && !seen[val]) { seen[val] = true; values.push(val); }
    });

    var shown = values.slice(0, 5);
    var extra = values.length - shown.length;

    var items = shown.map(function (value) {
      var withImage = null;
      var fallback = null;
      product.variants.forEach(function (v) {
        var val = [v.option1, v.option2, v.option3][colorIdx];
        if (val !== value) return;
        if (!fallback) fallback = v;
        if (!withImage && v.featured_image) withImage = v;
      });
      var match = withImage || fallback;
      var style = match && match.featured_image
        ? 'background-image:url(\'' + sizedImage(match.featured_image.src, 60) + '\');'
        : 'background-color:' + value.replace(/\s+/g, '').toLowerCase() + ';';

      return '<span class="product-card__swatch" title="' + escapeHtml(value) + '" style="' + style + '"></span>';
    }).join('');

    var more = extra > 0 ? '<span class="product-card__swatch-more">+' + extra + '</span>' : '';
    return '<div class="product-card__swatches">' + items + more + '</div>';
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function priceHtml(product) {
    if (product.price_varies) {
      return 'From ' + moneyFromCents(product.price_min);
    }
    return moneyFromCents(product.price);
  }

  function cardHtml(product) {
    var img = product.featured_image
      ? '<img src="' + sizedImage(product.featured_image, 500) +
        '" srcset="' + sizedImage(product.featured_image, 360) + ' 360w, ' +
        sizedImage(product.featured_image, 500) + ' 500w, ' +
        sizedImage(product.featured_image, 700) + ' 700w" ' +
        'sizes="(max-width: 589px) 50vw, (max-width: 989px) 33vw, 16vw" ' +
        'alt="' + escapeHtml(product.title) + '" loading="lazy">'
      : '';

    return (
      '<div class="product-card" data-product-id="' + product.id + '" data-wishlist-handle="' + product.handle + '">' +
        '<div class="product-card__image">' +
          '<a href="' + product.url + '">' + img + '</a>' +
          '<button type="button" class="product-card__wishlist js-wishlist-toggle is-active" ' +
            'data-product-id="' + product.id + '" data-product-handle="' + product.handle + '" ' +
            'aria-label="Remove ' + escapeHtml(product.title) + ' from wishlist">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#B06B78" stroke-width="2">' +
              '<path d="M12 21s-7-4.4-9.5-9A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 9.5 6c-2.5 4.6-9.5 9-9.5 9z"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        swatchesHtml(product) +
        '<a href="' + product.url + '" class="product-card__title">' + escapeHtml(product.title) + '</a>' +
        '<div class="product-card__price">' + priceHtml(product) + '</div>' +
      '</div>'
    );
  }

  function renderEmpty(container) {
    container.innerHTML =
      '<div class="wishlist-empty">' +
        '<p>Your wishlist is empty.</p>' +
        '<a href="/collections/all" class="btn">Continue Shopping</a>' +
      '</div>';
  }

  function renderError(container) {
    container.innerHTML = '<p class="wishlist-empty">We couldn\u2019t load your wishlist right now. Please refresh the page.</p>';
  }

  function removeCard(handle) {
    var grid = qs('#WishlistGrid');
    if (!grid) return;
    var card = grid.querySelector('[data-wishlist-handle="' + handle + '"]');
    if (card) card.remove();
    if (!grid.querySelector('.product-card')) renderEmpty(grid);
  }

  function init() {
    var grid = qs('#WishlistGrid');
    var loading = qs('#WishlistLoading');
    if (!grid || !window.SedrelleWishlist) return;

    var handles = window.SedrelleWishlist.getWishlist();

    if (handles.length === 0) {
      if (loading) loading.remove();
      renderEmpty(grid);
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      if (loading) loading.remove();
      var valid = products.filter(Boolean);

      if (valid.length === 0) {
        renderEmpty(grid);
        return;
      }

      grid.innerHTML = valid.map(cardHtml).join('');
      window.SedrelleWishlist.bindButtons();

      // If any stored handles no longer resolve to a real product (e.g.
      // deleted/unpublished), quietly drop them from storage so the count
      // badge stays accurate.
      if (valid.length !== handles.length) {
        var validHandles = valid.map(function (p) { return p.handle; });
        handles.forEach(function (h) {
          if (validHandles.indexOf(h) === -1) window.SedrelleWishlist.toggleProduct(h);
        });
      }
    }).catch(function () {
      if (loading) loading.remove();
      renderError(grid);
    });

    document.addEventListener('wishlist:change', function (e) {
      if (!e.detail.added) removeCard(e.detail.handle);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
